
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingpage/b2b",
      function () {
        return require("private-next-pages/landingpage/b2b/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingpage/b2b"])
      });
    }
  